import { useState, useEffect } from 'react';

function useValidateAnswers(isUpdateQuizScreen, currentAnswer, answerAlreadyUpdated) {
    const [isValid, setIsValid] = useState(false);

    useEffect(() => {
        if (!isUpdateQuizScreen) {
            if (currentAnswer) {
                setIsValid(true);
            } else {
                setIsValid(false);
            }
        } else {
            if (currentAnswer && answerAlreadyUpdated) {
                setIsValid(true);
            } else {
                setIsValid(false);
            }
        }
    }, [isUpdateQuizScreen, currentAnswer, answerAlreadyUpdated]);

    return isValid;
}

export default useValidateAnswers;
